import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/ui/lib/Button';
import { CustomTypography } from '@/shared/ui/Typography';

import { useConfirmPasswordExternal } from '../../model/telegramPersonal/useConfirmPassword';
import { TConfirmPasswordFormData } from '../../model/types';

import {
  ENTER_PASSWORD_FORM_ID,
  EnterPasswordTgPersonalForm,
} from './EnterPasswordTgPersonalForm';

interface ITelegramPersonalCloudPassword {
  channelId: string;
  onSuccess: () => void;
}
export const TelegramPersonalCloudPasswordExternal = ({
  channelId,
  onSuccess,
}: ITelegramPersonalCloudPassword) => {
  const { confirmPasswordExternal, ...mutation } = useConfirmPasswordExternal();
  const { t } = useTranslation();

  const handleSubmit = async (data: TConfirmPasswordFormData) => {
    if (channelId) {
      await confirmPasswordExternal(
        { channelId, password: data.password },
        onSuccess
      );
    }
  };

  return (
    <>
      <CustomTypography variant="h4">
        {t('channels:tgPersonal.enterPasswordTitle')}
      </CustomTypography>
      <EnterPasswordTgPersonalForm
        onSubmit={handleSubmit}
        mutation={mutation}
      />
      <Button
        type="submit"
        form={ENTER_PASSWORD_FORM_ID}
        loading={mutation.isPending}
        color="primary"
        variant="contained"
      >
        {t('channels:tgPersonal.confirmPassword.confirmBtn')}
      </Button>
    </>
  );
};
